class WhatsappModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));
    
    this.summaryToggle.querySelector('.close-whatsapp-button').addEventListener('click', (event) => {
      event.stopPropagation();
      event.preventDefault();
      this.detailsContainer.classList.add('hidden');
    });
  }

  connectedCallback() {
    this.addEventListener('click', (event) => {
      const clickedButton = event.target.closest('.chat-option-link');
      if (!clickedButton) return;

      const clickedOption = clickedButton.getAttribute('data-chat-option');
      if (!clickedOption) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'chat_widget_click',
        'chat_option': clickedOption,
        'region': 'BR'
      });

      if (typeof fbq === 'function') {
        fbq('trackCustom', 'ChatWidgetClick', {
          chat_option: clickedOption,
          region: 'BR'
        });
      }
    });
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
  }

  close() {
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
  }
}

customElements.define('whatsapp-modal', WhatsappModal);